import type { BuildingGraphPlanarTopology } from "building-types/building/buildingGraphTypes";
import { assertIsNotNullOrUndefined } from "common/utils/assertOfType";
import { planarGraphVertexStripToPolyLine2 } from "geom/planarGraph";
import type { PolyLine2 } from "geom/polyLine2Types";

export function planarTopologyFaceToPolyLine2(
  topology: BuildingGraphPlanarTopology,
  faceIndex: number,
  simplify = true,
): PolyLine2 {
  const vertexStrip = topology.planeTopology.planarGraph.faceVertices[faceIndex];
  assertIsNotNullOrUndefined(vertexStrip);
  return planarGraphVertexStripToPolyLine2(topology.planeTopology.planarGraph, vertexStrip, simplify);
}
